(function($) {
    _GMM_IOS_DO_LOGIN = false;//判断当前是否在登录中
    //支付宝api
    if (navigator.userAgent.indexOf('AlipayClient') > -1) {
        document.writeln('<script src="https://appx/web-view.min.js"' + '>' + '<' + '/' + 'script>');
    }
    $.SDLoader = function(title, imgUrl) {
        $('.modal-overlay').css({ visibility: 'visible', opacity: 0.4 });
    };
    //浮点数处理，以数组形式返回转换后的整数和放大倍数对象
    $.decToInt = function() {
        if (arguments.length == 0) {
            return [];
        }
        var decimalParams = [];
        var intParams = [];
        for (var i = arguments.length - 1; i >= 0; i--) {
            decimalParams[i] = arguments[i].toString();
            intParams[i] = {
                num: decimalParams[i].replace(".", ""),
                multiple: decimalParams[i].split(".").length == 1 ? 1 : Math.pow(10, decimalParams[i].split(".")[1].length)
            }
        };
        return intParams;
    };
    //4舍5入转化
    $.numberToFixed = function(num, decimalLenth) {
        if (isNaN(num)) {
            return num;
        } else {
            var f = new Number(num);
            return f.toFixed(decimalLenth);
        }
    };

    $.getCookie = function(c_name) {
        if (document.cookie.length > 0) {
            c_start = document.cookie.indexOf(c_name + "=");
            if (c_start != -1) {
                c_start = c_start + c_name.length + 1;
                c_end = document.cookie.indexOf(";", c_start);
                if (c_end == -1) c_end = document.cookie.length;
                return unescape(document.cookie.substring(c_start, c_end));
            }
        }
        return "";
    };

 $.setCookie = function(c_name, value) {
        var argv = arguments;
        var argc = arguments.length;
        var expires = (argc > 2) ? argv[2] : null;
        var path = (argc > 3) ? argv[3] : "/";
        var domain = (argc > 4) ? argv[4] : null;
        var theSecure = (argc > 5) ? argv[5] : false;
        var cookie_str = c_name + "=" + escape(value) + ((expires == null) ? "" : ";expires=" + expires.toGMTString()) + ((path == null) ? "" : (";path=" + path)) + ((domain == null) ? "" : (";domain=" + domain)) + ((theSecure == true) ? ";secure" : "");
        document.cookie = cookie_str;
    };


 //当天12点失效
    $.setCookieTime = function(c_name, value) {
        var argv = arguments;
        var argc = arguments.length;
        var expires = (argc > 2) ? argv[2] : null;

        var curDate = new Date();
            //当前时间戳
            var curTamp = curDate.getTime();
            //当前日期
            var curDay = curDate.toLocaleDateString();
            var curWeeHours = 0;
            var userAgent = navigator.userAgent;
            if (userAgent.indexOf("Safari") > -1) {
                //当日凌晨的时间戳,减去一毫秒是为了防止后续得到的时间不会达到00:00:00的状态
                curWeeHours = new Date(curDay).getTime() + (8 * 60 * 60 * 1000) - 1;
            } else {
                curWeeHours = new Date(curDay).getTime() - 1;
            }
            //当日已经过去的时间（毫秒）
            var passedTamp = curTamp - curWeeHours;
            //当日剩余时间
            var leftTamp = 24 * 60 * 60 * 1000 - passedTamp;
            var leftTime = new Date();
            leftTime.setTime(leftTamp + curTamp);

        var path = (argc > 3) ? argv[3] : "/";
        var domain = (argc > 4) ? argv[4] : null;
        var theSecure = (argc > 5) ? argv[5] : false;
        var cookie_str = c_name + "=" + escape(value) + (";expires=" + leftTime.toGMTString()) + ((path == null) ? "" : (";path=" + path)) + ((domain == null) ? "" : (";domain=" + domain)) + ((theSecure == true) ? ";secure" : "");
        document.cookie = cookie_str;
    };


   $.isEmptyObject =function(obj)
        {
            for (var key in obj) {
                return false
            }
            return true
        };

    //删除url参数
    $.delQueryStringByName = function(url,paramKey){
        var urlParam = url.substr(url.indexOf("?")+1);
        var beforeUrl = url.substr(0,url.indexOf("?"));
        var nextUrl = "";

        var arr = new Array();
        if(urlParam!=""){
            var urlParamArr = urlParam.split("&");

            for(var i=0;i<urlParamArr.length;i++){
                var paramArr = urlParamArr[i].split("=");
                if(paramArr[0]!=paramKey){
                    arr.push(urlParamArr[i]);
                }
            }
        }

        if(arr.length>0){
            nextUrl = "?"+arr.join("&");
        }
        url = beforeUrl+nextUrl;
        return url;
    };
    //取url参数
    $.getQueryStringByName = function(paramName) {
        var result = location.search.match(new RegExp("[\?\&]" + paramName + "=([^\&]+)", "i"));
        if (result == null || result.length < 1) {
            return "";
        }
        return result[1];
    };
    $.getQueryStringByNameOfEncodeUrl = function(paramName) {
        var result = decodeURIComponent(location.search).match(new RegExp("[\?\&]" + paramName + "=([^\&]+)", "i"));
        if (result == null || result.length < 1) {
            return "";
        }
        return result[1];
    };
    var _CUR_DOMAIN_PROTOCAL = location.protocol;
    var _GMM_LOGIN_COOKIE_NAME = "gmm_login_status";
    var _GMM_LOGIN_MYGM_LOGIN_TICKET = "ticket";
    var _GMM_LOGIN_BACK_URL_AFTER_MYGM = _CUR_DOMAIN_PROTOCAL + "//" + location.host + "/m/my/login.html";
    var _GMM_LOGIN_MYGM_LOGIN_PAGE_URL = location.host == "dev.gmmsj.com" ? _CUR_DOMAIN_PROTOCAL + "//devgmmwlogin.gmmsj.com/v1/oauth/authorize?appid=791000270&state=123&mode=self&display=layer" : _CUR_DOMAIN_PROTOCAL + "//gmmwlogin.gmmsj.com/v1/oauth/authorize?appid=791000270&state=123&mode=self&display=layer";
    var _GMM_LOGOUT_MYGM_LOGIN_PAGE_URL = location.host == "dev.gmmsj.com" ? _CUR_DOMAIN_PROTOCAL + "//devgmmwlogin.gmmsj.com/v1/sso/logout?redirect_url=" : _CUR_DOMAIN_PROTOCAL + "//gmmwlogin.gmmsj.com/v1/sso/logout?redirect_url=";
    var _GMM_LOGIN_GMMINF_URL = "/gmminf/user/login";
    var _GMM_LOGIN_GMMINF_LOGOUT_URL = "/gmminf/user/logout";
    var _GMM_LOGIN_CALLBACK_DEFUALT_PAGE = _CUR_DOMAIN_PROTOCAL + "//" + location.host + "/h5/my/index/index.html";
    var _GMM_LOGIN_ERROR_MSG = "登录繁忙，请稍候尝试再次登录！";
	$.isWeiBo = function () {
		return navigator.userAgent.toUpperCase().indexOf('WEIBO') > -1;
	};
    //登录信息
    $.isLogin = function() {
        return $.getCookie(_GMM_LOGIN_COOKIE_NAME) == "1";
    };
    $.getLoginBUid = function() {
        return $.getCookie("b_uid");
    };
    $.getLoginPhone = function() {
        return $.getCookie("phone");
    };
    $.getLoginNickname = function() {
        return $.getCookie("nickname");
    };
    $.getLoginDisplayAccount = function() {
        return $.getCookie("displayAccount");
    };
    $.getLoginImage = function() {
        return $.getCookie("image");
    };
    //如果传入回调函数，会被优先使用
    $.checkNotLogin = function(f) {
        if ($.isLogin() == false) {
            $(document).trigger("gmm_notlogin", ["page", f ? f : arguments.callee.caller]);
            return true;
        }
        return false;
    };



   $.getScrollTop = function(){
        var scrollPos;
        if (window.pageYOffset) {
        scrollPos = window.pageYOffset; }
        else if (document.compatMode && document.compatMode != 'BackCompat')
        { scrollPos = document.documentElement.scrollTop; }
        else if (document.body) { scrollPos = document.body.scrollTop; }
        return scrollPos;
    };


    $.os = function(){
        var u=navigator.userAgent.toUpperCase();
        var platform = 'pc'
        if(u.indexOf("ANDROID")>-1){
            platform = "android";
        }
        if(u.indexOf("GMM-IOS")>-1){
            platform = "gmmios";
        }
        if(u.indexOf("IPHONE")>-1 || u.indexOf("IPAD")>-1 || u.indexOf("ITOUCH")>-1){
            platform = "ios";
        }
        return platform;
    };

    $.osChannel = function() {
        var u=navigator.userAgent.toUpperCase();
        if(window.ymm) {
            return 'android_gmm'//安卓app
        }
        if(u.indexOf('ANDROID') > -1) {
            if (window.USER || $.getQueryStringByName('webview') == 1) {
                window.localStorage.setItem('dyAndroid','true')//安卓叨鱼app 写入localStorage
            }
            if(window.localStorage.getItem('dyAndroid') === 'true') {
                return 'android_daoyu'//安卓叨鱼app
            }
            return 'android_browser'//安卓所有浏览器
        }
        if(u.indexOf('GMM-IOS') > -1) {
            return 'ios_gmmx'//ios新app
        }
        if(u.indexOf("IPHONE") > -1 || u.indexOf("IPAD") > -1 || u.indexOf("ITOUCH") > -1){
            if (window.USER || $.getQueryStringByName('webview') == 1) {
                window.localStorage.setItem('dyIOS','true')//IOS叨鱼app 写入localStorage
            }
            if(window.localStorage.getItem('dyIOS') === 'true') {
                return 'ios_daoyu'//IOS叨鱼app
            }
            if(u.indexOf('SAFARI') > -1 || u.indexOf('UCBROWSER') > -1 || u.indexOf('SOGOU') > -1 || u.indexOf('MQQ') > -1 || u.indexOf('BROWSER') > -1 || u.indexOf('WEIBO') > -1) {
                return 'ios_browser'//浏览器
            }
            return 'ios_gmm' //老版ios
        }

        return 'pc'
    };

    //修改url中参数的值
    $.changeURLArg = function(url,arg,arg_val){
        var pattern=arg+'=([^&]*)';
        var replaceText=arg+'='+arg_val;
        if(url.match(pattern)){
            var tmp='/('+ arg+'=)([^&]*)/gi';
            tmp=url.replace(eval(tmp),replaceText);
            return tmp;
        }else{
            if(url.match('[\?]')){
                return url+'&'+replaceText;
            }else{
                return url+'?'+replaceText;
            }
        }
    };
    //alterAcc ==1 表示切换账号
    $.forceLogin = function(alterAcc, f) {
        var callback = f ? f : arguments.callee.caller;
        $(document).trigger("gmm_notlogin", ["page", callback, alterAcc]);
    };
    var _gmm_continue_callback; //保存登录后回调 js function
    $.setLoginCallbackIfAjaxRespsoneLogout = function(callback) {
        if (typeof(callback) == "function") {
            _gmm_continue_callback = callback;
        }
    };
    //alterAcc=1 表示切换账号
    $(document).bind("gmm_notlogin", function(e, eventSource, callback, alterAcc) {
        console.log("[GMMNotLogin Event] Source=%s", eventSource);
        if (typeof(callback) == "function") {
            _gmm_continue_callback = callback;
        }
        setTimeout(function(){
            if ($.os()=="gmmios"){//gmmios 新app
                $.loginInApp();
            } else if ($.isAlipayClient()){//支付宝小程序
                $.loginInAliApp();
            } else if( ($.os()=="ios" && window.bridge && !$.isWeiBo()) || ($.os()=="android" && window.ymm) ){//gmmios老app和安卓
                $.loginInApp();
            } else {
                $.showLoginPage("", alterAcc);//其他浏览器，app打开
            }
        }, 500);
    });
    $(document).bind("gmm_haslogin", function(e, eventSource) {
        console.log("[GMMHasLogin Event] Source=" + eventSource);
        if (typeof(_gmm_continue_callback) == 'function') {
            _gmm_continue_callback();
            $.getVersionyhq(function (ret) {
                if(ret ==1 ){
                    var homebanner = $.getCookie("homebaner");
                    if(homebanner=="homebaner"){
                    }else {
                        $.getpackage();
                    }

                }else if (ret ==0){
                    $(".page-index .index-banner").hide();
                }
            });
        } else {
            console.log("[GMMHasLogin Event] No callback");
        }
    });

    function os(){
        var u=navigator.userAgent.toUpperCase();
        if(u.indexOf("ANDROID")>-1){
            return "android";
        }
        if(u.indexOf("GMM-IOS")>-1){
            return "gmmios";
        }
        if(u.indexOf("IPHONE")>-1 || u.indexOf("IPAD")>-1 || u.indexOf("ITOUCH")>-1){
            return "ios";
        }
        return "pc";
    };

    function call_ios_method(method_name,callback,mock_msg,params){
        if(typeof(callback) == "undefined"){
            callback=function(){};
        }
        if(typeof(mock_msg) == "undefined"){
            mock_msg=method_name+" called.";
        }
        if(window.bridge){
            try{
                if(typeof(params) == "undefined"){
                    window.bridge.callHandler(method_name,callback);
                }else{
                    window.bridge.callHandler(method_name,params,callback);
                }
            } catch (e) {
            }
        }else{
            console.log(mock_msg);
        }
    }


    $.getLoginStatus= function(callback){
            if($.os()=="ios" || $.os()=="gmmios"){
                call_ios_method("getLoginStatus",function(ret){
                    callback(ret);
                },"getLoginStatus",{});
        }
    }

    $.getNewUserCoupons= function(data){
        if($.os()=="ios" || $.os()=="gmmios"){
            call_ios_method("getNewUserCoupons",function(ret){
            },"getNewUserCoupons",data);
        }
        $.setCookie("homebaner","");
    }

    $.hideNav= function(data){
        if($.os()=="ios" || $.os()=="gmmios"){
            call_ios_method("hideNav",function(ret){
            },"hideNav",data);
        }
    }
    $.showTabbar= function(data){
        if($.os()=="ios" || $.os()=="gmmios"){
            call_ios_method("showTabbar",function(ret){
            },"showTabbar",data);
        }
    }
    $.gbaoPay = function(data,callback){
        if(window.bridge && !$.isWeiBo()){
            call_ios_method("gbaoPay",function(ret){
                callback && callback(ret)
            },"gbaoPay",data);
        }
    }
    $.showChatList = function(data){
        if(window.bridge && !$.isWeiBo()){
            call_ios_method("showChatList",function(ret){
            },"showChatList",data);
        }
    }
    $.showNavTitle = function(title) {
        if($.os()=="ios" || $.os()=="gmmios"){
          call_ios_method("setnavititle",function(){}, "setnavititle", title)
        }
    }
    $.showNav= function(data){
        if($.os()=="ios" || $.os()=="gmmios"){
            call_ios_method("showNav",function(ret){
            },"showNav",data);
        }
    }
    $.appLogout = function(data){
        if($.os()=="ios" || $.os()=="gmmios"){
          call_ios_method('logout',function(ret){
          },'logout',data)
        }
    }

    $.loginInApp = function(){
        // var homebanner = $.getCookie("homebaner");
        // if(homebanner =="homebaner"){
        //     $.getNewUserCoupons();
        // }

        var appId = "791000270";
        doLogin();
        function call_ios_method(method_name,callback,mock_msg,params){
            if(typeof(callback) == "undefined"){
                callback=function(){};
            }
            if(typeof(mock_msg) == "undefined"){
                mock_msg=method_name+" called.";
            }
            if(window.bridge){
                try{
                    if(typeof(params) == "undefined"){
                        window.bridge.callHandler(method_name,callback);
                    }else{
                        window.bridge.callHandler(method_name,params,callback);
                    }
                } catch (e) {
                }
            }else{
                console.log(mock_msg);
            }
        }
        function doLogin(callback_after_login){

            if(window.bridge){
                if(_GMM_IOS_DO_LOGIN)return;
                _GMM_IOS_DO_LOGIN = true;
                var limit = 0;
                var bridgeFlag = self.setInterval(function () {
                    if (window.bridge) {
                      try {
                            window.clearInterval(bridgeFlag);
                            call_ios_method("login",function(ret){
                                var response = JSON.parse(ret);
                                if(typeof(response)!="undefined" && typeof(response["ticket"])!="undefined" &&  response["ticket"]!=""){
                                    //gmmios里登录态过期不验票，调完原生登录即可，原生写入sessionid
                                    if ($.os()=="gmmios"){
                                        $.loginByTicket(response["ticket"]);//ios 14.7.0版本后，原生不能正常写入sessionid，由h5验票登录，14.7.0版本前能正常写入的则不会进入此处
                                        return;
                                    }
                                    $.showLoginPageWithTicket(response["ticket"]);
                                }
                            },"login",{'appId': appId, 'areaId': "0"});
                      } catch (e) {
                            window.clearInterval(bridgeFlag)
                      }
                    } else {
                      limit += 1;
                      if (limit > 100) {
                        window.clearInterval(bridgeFlag)
                      }
                    }
                }, 50);

                //用轮询window.bridge方式来调用，这里不用了
                // call_ios_method("login",function(ret){
                //     var response = JSON.parse(ret);
                //     if(typeof(response)!="undefined" && typeof(response["ticket"])!="undefined" &&  response["ticket"]!=""){
                //         //gmmios里登录态过期不验票，调完原生登录即可，原生写入sessionid
                //         if ($.os()=="gmmios"){
                //             return;
                //         }
                //         $.showLoginPageWithTicket(response["ticket"]);
                //     }
                // },"login",{'appId': appId, 'areaId': "0"});
            }else{
                window.loginCallback = function (code, msg, ticket) {
                    if(ticket){
                        $.showLoginPageWithTicket(ticket);
                    }
                };
                if(typeof(window.ymm)!="undefined"){
                    window.ymm.login(appId, "0", "loginCallback");
                }
            }
        }

    }
    /**
     * @description: 登录支付宝小程序
     * @param {*} backUrl 登录后回跳地址
     * @return {*}
     */    
    $.loginInAliApp = function(){
        var limit = 0;
        var bridgeFlag=setInterval(function () {
            if(my){
              try{
                window.clearInterval(bridgeFlag)
                my.postMessage({
                    name:"login",
                    url:window.parent.location.origin + '/h5/common/login/index.html?back_url=' + encodeURIComponent(window.parent.location.href)
                });
              } catch (e) {
                window.clearInterval(bridgeFlag)
              }
            }else{
              limit+=1;
              if(limit>100){
                window.clearInterval(bridgeFlag)
              }
            }
        },50);
    }
    $.closecoupon =function () {
        $.closeModal(".couponpop");
        $(".couponpop").remove();
        $(".page-index .content").removeClass("fixcontent");
    }

    $.getVersionyhq = function (callback) {
        var self = this;
        var yhq_url = "/gmminf/accountapi/config";
        var params_data = {
            src_code: 11,
            type: "new_users_coupon_config"
        };
        var query_params = {
            method: "GetVersion",
            src_code: 11,
            params: JSON.stringify(params_data)
        };
        $.ajaxBridgeCache(yhq_url,
            function (response) {
                if (response.return_code === 0) {
                    var openflag = response.data.memo.open_flag;
                    if (typeof (callback) == "undefined") {
                        if (openflag == 1) {
                            if ($.isLogin() == true) {
                                $(".page-index .index-banner").hide();
                            } else {
                                $(".page-index .index-banner").show();
                            }
                            if (window.bridge && !$.isWeiBo()) {
                                $.getLoginStatus(function (ret) {
                                    if (ret) {
                                        $(".page-index .index-banner").hide();
                                    } else {
                                        $(".page-index .index-banner").show();
                                    }
                                });
                            }

                        } else if (openflag == 0) {
                            $(".page-index .index-banner").hide();
                        }
                    } else {
                        callback(openflag);
                    }

                } else {
                    $.toast(response.return_message);
                }
            },
            query_params, "GET", false, 0,
            function (response) {
                return $.BizReturnCodeCheck(response);
            },
            null
        )

    },

    /*20180421 新发优惠券相关*/
    $.gotoGoodList =function (goods_type,gameAppIds) {
        if (gameAppIds > 0){
            location.href = '/h5/goods/list/index.html?goods_type=' + (goods_type || '') + '&game_id=' + gameAppIds
        } else {
            //location.href = '/m/buyselect/selgame.html'
            location.href = '/h5/selgame/index.html'
        }
    }
    //查用户所有优惠券
    $.queryUserCoupons = function(){
        var self = this;
        var url = "/gate/frontconfigapi";
        var query_params = {
            method: "queryUserCoupons",
            params: JSON.stringify({
                "sorted": 2,
                "orderby": 2
            })
        };
        $.ajaxBridgeCache(url,
            function (response) {
                if (response.return_code === 0) {
                        var listall=""
                        var couponList = response.data.list
                        var now = new Date().getTime()

                    if(couponList && couponList.length > 0){
                        couponList = couponList.filter(function(item){
                            var endTimeArr = (item.endTime.trim()+'').split(/[- : \/]/)
                            var endTime = new Date(endTimeArr[0],endTimeArr[1]-1,endTimeArr[2],endTimeArr[3],endTimeArr[4],endTimeArr[5]).getTime()
                            return endTime > now;
                        });
                        $.each(couponList, function (i, item) {
                            listli= '<li>'+
                                '<div class="box">' +
                                '<div class="cprice item"><i class="sp">¥ </i><i class="bp">'+item.amount/100+'</i></div>'+
                                '<div class="cname item">' +item.name+ '</div>'+
                                '<div class="use item" onclick="javascript:$.gotoGoodList(' + item.itemtypes + ',' + item.gameAppIds + ')">立即<br />使用</div>'+
                                '</div>'
                            '</li>';
                            listall+=listli;
                        })
                        var popupHTML =
                            '<div class="popup-coupon-list">'+
                            '<div class="coupons" style="display: flex!important;z-index: 10601">'+
                            '<div class="outer">'+
                            '<div class="modal-result">'+
                            '<div class="list-container">' +
                            '<ul>'+ listall+'</ul>' +
                            '</div>' +
                            '<p class="tips">请在“我的-钱包-优惠券”中查看您的优惠券</p>' +
                            '<p><a class="btn" onclick="javascript:$.closeUserCoupon()">我知道了</a></p>'+
                            '</div>'+
                            '</div>'+
                            '</div>'+
                            '</div>';
                        (couponList.length > 0) && ($.popup(popupHTML, true));

                    }

                } else {
                    $.toast(response.return_message);
                }
            },
            query_params, "GET", false, 0,
            function (response) {
                return $.BizReturnCodeCheck(response);
            },
            null
        )
    }
    $.closeUserCoupon =function () {
        $.closeModal(".popup-coupon-list");
        $(".popup-coupon-list").remove();
        $(".page-index .content").removeClass("fixcontent");
        var self = this;
        var url = "/gate/actapi/readNewCoupons";
        var query_params = {
        };
        $.ajaxBridgeCache(url,
            function (response) {
            },
            query_params, "GET", false, 0,
            function (response) {
                return $.BizReturnCodeCheck(response);
            },
            null
        )
    }
    //查是否有新优惠券
    $.doHaveNewCoupons = function () {
        var self = this;
        var url = "/gate/actapi/doHaveNewCoupons";
        var query_params = {
        };
        $.ajaxBridgeCache(url,
            function (response) {
                if (response.return_code === 0) {
                    if (response.data.has_new == 1){
                        if($.os()=="gmmios"){
                            setTimeout(function(){
                                window.bridge.callHandler('showCouponList',function(){})
                            },1000)
                        } else {
                            $.queryUserCoupons()
                        }
                    }
                } else {
                    $.toast(response.return_message);
                }
            },
            query_params, "GET", false, 0,
            function (response) {
                return $.BizReturnCodeCheck(response);
            },
            null
        )
    }
    /*20180421 新发优惠券相关 end*/

    $.updateReceiveFlag=function () {
        var self =this;
        var params = {}
        var query_params = {
            method: "updateReceiveFlag",
            params: JSON.stringify(params)
        };
        $.ajaxBridgeCache('/gate/frontconfigapi',
            function (response) {
                if (response.return_code === 0) {
                } else {
                    $.toast(response.return_message);
                }
            },
            query_params, "GET", false, 0,
            function (response) {
                return $.BizReturnCodeCheck(response);
            },
            null
        )

    };

    //立即领取
    $.getpackage = function (banner) {
        if ($.checkNotLogin()) return;
        var self = this;
        var params = {}
        var query_params = {
            method: "checkReceiveFlag",
            params: JSON.stringify(params)
        };
        $.ajaxBridgeCache('/gate/frontconfigapi',
            function (response) {
                if (response.return_code === 0) {
                    var data = response.data;
                    if (data.is_new_user == 1) {
                        if (data.receive_flag == 0) {
                            var raffle_info = "";
                            if (data.raffle_info) {
                                raffle_info = JSON.parse(data.raffle_info);
                                if (raffle_info.coupon.length > 0) {
                                    var coupon = raffle_info.coupon;
                                    var listall=""
                                    $.each(coupon, function (i, item) {
                                        listli= '<li>'+
                                            '<div class="cprice"><i class="sp">￥</i><i class="bp">'+item.coupon_amount+'</i></div>'+
                                            '<div class="cname">'+item.item_type_name+ item.kind_name+ '</div>'
                                        '</li>';
                                        listall+=listli;
                                    })

                                    var popupHTML =
                                        '<div class="couponpop">'+
                                        '<div class="coupons" style="display: flex!important;z-index: 10601">'+
                                        '<a href="javascript:void(0)" class="coupons-close" onclick="javascript:$.closecoupon()"></a>'+
                                        '<div class="dialog-main dialog-main-blank">'+
                                        '<div class="modal-result" id="clickview">'+
                                        '<div class="suc-item">'+
                                        '<div class="suc-box">'+
                                        '<p>团子已经把<span>新人礼券</span></p>'+
                                        '<p>放到你的账户里啦</p>'+
                                        '<ul class="suc-list">'+ listall+'</ul>'+
                                        '</div>'+
                                        '</div>'+
                                        '<a href="http://qb.sdo.com/m/coupon/couponlist.html" class="sign-btn" >点击查看</a>'+
                                        '</div>'+
                                        '</div>'+
                                        '</div>'+
                                        '</div>';
                                    $(".page-index .content").addClass("fixcontent");
                                    $.popup(popupHTML, true);
                                    $.updateReceiveFlag();
                                    $(".page-index .index-banner").hide();
                                    return;

                                } else {}

                            }
                        } else {
                            var homebanner = $.getCookie("homebaner");
                            if( typeof(banner)!="undefined" ||  homebanner =="homebaner" ){
                                var popupHTML =
                                    '<div class="couponpop">'+
                                    '<div class="coupons" style="display: flex!important;z-index: 10601">'+
                                    '<a href="javascript:void(0)" class="coupons-close" onclick="javascript:$.closecoupon()"></a>'+
                                    '<div class="dialog-main dialog-main-blank">'+
                                    '<div class="modal-result" id="clickview">'+
                                    '<div class="old-user">'+
                                    '<h2>丸子哭着对你说</h2>'+
                                    '<p>该礼券仅限新用户领取，快去看看</p>'+
                                    '<p>你领过的券尽快使用吧</p>'+
                                    '</div>'+
                                    '<a href="http://qb.sdo.com/m/coupon/couponlist.html" class="sign-btn" >立即查看</a>'+
                                    '</div>'+
                                    '</div>'+
                                    '</div>'+
                                    '</div>';
                                $(".page-index .content").addClass("fixcontent");
                                $.popup(popupHTML, true);
                                $.setCookie("homebaner","");
                                $(".page-index .index-banner").hide();
                                return;
                            }
                        }

                    } else if (data.is_new_user == 0 ) {
                        var homebanner = $.getCookie("homebaner");
                        if( typeof(banner)!="undefined" ||  homebanner =="homebaner" ){
                            var popupHTML =
                                '<div class="couponpop">'+
                                '<div class="coupons" style="display: flex!important;z-index: 10601">'+
                                '<a href="javascript:void(0)" class="coupons-close" onclick="javascript:$.closecoupon()"></a>'+
                                '<div class="dialog-main dialog-main-blank">'+
                                '<div class="modal-result" id="clickview">'+
                                '<div class="old-user">'+
                                '<h2>丸子哭着对你说</h2>'+
                                '<p>该礼券仅限新用户领取，快去看看</p>'+
                                '<p>你领过的券尽快使用吧</p>'+
                                '</div>'+
                                '<a href="http://qb.sdo.com/m/coupon/couponlist.html" class="sign-btn" >立即查看</a>'+
                                '</div>'+
                                '</div>'+
                                '</div>'+
                                '</div>';
                            $.popup(popupHTML, true);
                            $.setCookie("homebaner","");
                            $(".page-index .index-banner").hide();
                        }else{

                        }
                    }
                } else {
                    $.toast(response.return_message);
                }
            },
            query_params, "GET", false, 0,
            function (response) {
                return $.BizReturnCodeCheck(response);
            },
            null
        )
    };
    $.showLoginPageWithTicket = function(ticket){
        var login_url = '/m/my/login.html?state=1&ticket=' + ticket;
        var popupHTML = '<div class="popup">' +
            '<div class="content-block" style="height:100%">'+
            '<iframe id="loginIframe" src="'+ login_url  + '"  frameborder="0" style="height:100%;visibility:inherit;width:100%;z-index:1;"></iframe>'
            '</div>' +
            '</div>';
        $.loginpanelHasShown = true;
        $.popup(popupHTML, true);

    };
    $.showLoginPage = function(backUrl,alterAcc){
		//if($.loginpanelHasShown && $.loginpanelHasShown == true) return;
		if(typeof(backUrl) == "undefined"){
			backUrl="";
		}
		if(backUrl==""){
			backUrl=window.location.href;
		}


		var backurl_after_mygm=_GMM_LOGIN_BACK_URL_AFTER_MYGM+"?back_url="+encodeURIComponent(backUrl);
		var login_url=_GMM_LOGIN_MYGM_LOGIN_PAGE_URL+"&redirect_url="+encodeURIComponent(backurl_after_mygm) + "&alteracc="+alterAcc;
		var popupHTML = '<div class="popup">' +
		    '<div class="content-block" style="height:100%">'+
			'<iframe id="loginIframe" src="'+ login_url  + '"  frameborder="0" style="height:100%;visibility:inherit;width:100%;z-index:1;"></iframe>'
		    '</div>' +
		    '</div>';
		$.loginpanelHasShown = true;
        $.popup(popupHTML, true);
	};

    $.showLoding = function(){
        var loadimg = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKsAAACrCAYAAAAZ6GwZAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NEI4RkM4NEIxMzYwMTFFNkI4OERBNzZGNTg5REQxQjciIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NEI4RkM4NEMxMzYwMTFFNkI4OERBNzZGNTg5REQxQjciPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo0QjhGQzg0OTEzNjAxMUU2Qjg4REE3NkY1ODlERDFCNyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDo0QjhGQzg0QTEzNjAxMUU2Qjg4REE3NkY1ODlERDFCNyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PhgxykAAABFrSURBVHja7J0LtJVjGsefRAqrKOmyUDghxbgThlAU1sJa7mUw4345muXO1BqXRQwrhcEwYch9LTULkeQ0brk3rqV0M4uKSi1ddJ3n3/d87Wd/7X3Ovu9v7/3/rfVffd+792nv877/837Pe2+2bt06IWlpptpRtZOqi2kHVQdVW1U7+3dz1RaqzSI/v0q1TPWbaqFqgf07T/W9arZppmqOioXRWGHQrBuA4fZVHaTaS9XDtGWJPn+p6ivT56oPVJ+a0UmNmxUm7K06WnWoap8UNWO5Qc38mepd1ZuqBjM1zVoD7Ko6WdVfdUiG5oRhZqhmucf2PHu8P53l559l4UIHF1Z0Ve2cxXeBcV9TvaT6lmatLvZQnWEm7dnEexFTTlJ9bI/jL1TTVatTvHdr1aIsv8s2ql9SpG+qqlPtaaHH/qqDLSZujC/NtM+qvqZZKxOY4kzVuaoDGnnfD6rxJph0WhafUUizNvYkQAzdx9S5kfd+pHpc9UwO34tmLQP7qeqtJm2R4vV19hgdbY/Sr/L4rFKYNQpq3X6qkyzObpbiPSutph2h+oRmjRebqE5RDVL1SvOeiVaAY1Q/Fuhzy2FWTyfVifaHeUSa97yvulf1omotzVo+EOcNVF2n2j3F62gQPWGaWYy8U7XJ8mcWS3H6UtEPfI6pa4rXp6juVD2VJv6mWYtYk8KkQ1S7pHj9DdV9qleqoTbJIW+OV12h6pvi9e9Ut5hp19KsxaW/1RB7RtLRpfOYPfK+EQK6W2h0nmzcLYZBh+tVY2nWwrO71ZZ9IukrVI+o7pZguJJsDIaLr1ZdoGoZeW281cJTaNb8QQf6YNVVkdphjeqfqr8WsMFU7XSy/PqTqnnkqXSP6lYJBjpo1hw4xmrNHSPpY+wRNoX+y/kpNdR6EjxzrPYdF+eAPG60NpO+HjHqVDPwSTRqXkyxPDzG8tSHC69b3rdmzdo06C98UoJpeCHLVbdZXLqSXisoGDi5RnWTqpVLx/TFsyXon6ZZIzS32HRwpLZ/R/VHyW4YlGRPN9VI1WEuba3FsbdaG4FmtcD/GUkehUFteqMEQ4Zr6aWShYQYqr49Usuidj0zDg3ZcpsVM4swa6ijS8N4/emS37g9yR3MP3jO/g2ZK8GstUm12sA6z/5qvVEflWCWFI1aPr6yMnjUpXW0sjqv1szazBpLIyUxMwqd+xhCvcBCAFJelltZDLSyCRtjI63smtVCGIBf+F/2mA/5nwRdKZ/QI7EE0y4xpXJ7l4Yw4Q9S4t6ZUpq1jf3SvV3a+xYLzaMnYk0Ha1v4KZgNVsksrrYwAEYdFzEqfvk+NGpFMM/KarRL621l2qaazNpegv7SA13aQ6pTJeZj0SQJlNUpVnYhB1rZtq8Gs+KXmCDJC/Uwxe8SiUlHM8mKNVZ2d7q0nlbG7SvZrHg8jI0YFR3917PMK57rrSy9YccWOyQollkxte/f1pIMuUF1B8u5arjDytT3Goyxsq8Ysza3ro3DXRrGl4eyfKuOoVa2IUdY2TevFLNiackJ7h4z/IewXKsWlO397v4E80DBKXQ/K5ZIjHD3oySYasbd36objGhhaucAl1ZvFVUszXqs6lVXW6NLA5uecQ5qbYDRSWweF04zxGy54ySY0B0rs3aVYHvGbewe+0NhRtUClmFNgb25MDOrzu6xCQi2EZ0Vl5gVKyZfdEZdYnELjVp7LLCyX2L325g3No+LWe+V5C4q7AoyleVWs0w1D4TAG8PjYFZMZLjI3WNkYzTLq+aBB+5y9/DIieWMWbEcBTt7bOsaVL2Fw6gkAH2tDa7B9bME29/nvDwm15oVXRUjnVERowykUYljjXkijF+3Nc80K7VZEZP0c/eXSrB9OSGe2eaNkH6ReLboYcB2Emx+1tbuX1CdxnIhjfC8BFNCAY5WwqZx80tRsw53RsUHX86yIE1wuXlFzDs59Q5ka9ajJNhpOeTqXP5CSM0x37wScoZ5qWhhAHaaxplM4fxUTLjFUgeO+5NMG+UYjj3S7nHSDM4ey3gn7mxq1gucUdHSq6dRSRbAK1dIoseop3mq4DUrDnuYJomuqr+rLmP+kxx4wPUQoO8V8wgyWiGbac06yBkVkxMGM89JjgyWxCk38NSfCxkGtDOzhtzlWnaEZMtCSR6KHSSJ3qW8zYr9O8OFYNigawTzm+TJCPOSmLeuLYRZt47EppiowrX+JF+WSfJy7svMa3mZ9WLVVq5WfYj5TArEQ6523cq8lrNZsUyhPlJ1r2AekwKxIhJS1kvq83YzMisWf3Wy66WqB5m/pMA8aN4S89qAXM16ibv+hxTugFxCQuCpR9J4biPSDQrsLcHQaggOSJjOvCVFAIMC/oATDMFOzqZmvdBdT6BRSRGZbh5L5b0mzdoyEjs8zPwkRebhSFupZaZmxRHg4QlzGG3gAkBSbEZLYlS0tXkwI7Oe6a6xCoA7qpBis9K8lsqDaRtYGPqa66rh3hKzIxFJ1YIdCBvsGn2wOMdgSWM1az9n1B9UbzMPSYl42zwXtpv6NxUG+K0qcUAFj6IkpWKteS6VFzcya/OIm19h/pES4z3XXyKbEnuz4uSNdnaNWTFvMe9IiXlLErP62knyCT9JZj3aXb8pnLRCSs8K814qTyaZtbe7nsB8I2ViQhpPbjArllkf4tL/wzwjZewVCDnEvJlk1v1VrewafVv/ZZ6RMjFZEv2rrcybSWb1gey7wt0ASflYYx6UqDdDs+7tXvyM+UXKjPfg3lGz+m3WP2FekTLjPbjBm5gbgHUvS10gu4tqBvOLlJGdVd/ZNfbC2lK1EjVrN2fUJTQqiQEzXCNrU/Po+jCgzr2JKwJIXPBerEtl1mnMIxITptGspKLN2sUlzmQekZjgvdglNOt2LvFH5hGJCd6L24Vm7ewS5zKPSEzwXuzMmpVUXM0anrYyT3jyCokP882T4fX6Dte+qpMlWLvNNVckLsCLOA0Ih1mvX5uVz0HDhJSUTZgFhGYlhGYlNCshNCshNCuhWQmJr1l7qP4iiROvCYkLPc2b8Oj6QQGMwXaUYGgLEwY4ikXiUpFiC0zs0wqPdoZZsSAr3K0NZxFx5hWJAx0lMZkFewlsCvf+5N7QiXlEYoKfujrfV7XezYTEgQ7u+ofQrPNYs5JKqVnnuMSdmEckJnR117NDs/pVhN2YRyQmeC9OD806nWYllWjWOuYRiQl1qcyKMGC1JbZm3EpiwM6SOJJ1dRiqwqw4ivAb98Z9mFekzPj9gr82j26YyPKxe3E/5hUpMyn3Cw7NOpk1K4kR3oOTo2b90L14qEROdiOkhDQ3D0rUmz4MWO4aWb9jnpEyxqth42qZD1E3cS2u99wPHM48I2Xi9+76fUn0VCWtFGhw10cxz0iZOCqNJ5PMGj0zsyXzjZSYlrLxGcIpzYpAdoFdb6E6knlHSsyR5j0xL36YzqyYjT3W3R/PvCMlxnturEROuoyubn3ZXZ8sXP1KSscm5rlUXkxp1tckOPMddI60zAgpdi9AOOF6ReQpn9Ksi1WvuPszmYekRHivwYNLmjIreMZdn6pqwXwkRaaFeS2VBxs1q3d1Wwl2HiakmJxkXhPz3iuZmhXxwih3fxHzkhQZ77FRrt2URLpt2jE+6898xxIDnutKigFWBPh1gJhxNTnTmlXszR+5+0uZp6RIXOauP0pn1MbMCh501xeqtma+kgIDT12QxnNZmRWxQ7jX0JaqS5i3pMBcYt4S89qoXM2KdS8j3H29cHILKRwtzVMhI8xzOZkVPKT61a6xD9bFzGNSIC6WxN5qv5rXJB+z/qJ6wN1fJ4lZMYTkyhbmpZAHzGt5mRX8TYJh2LB2rWdekzypd7UqvHVXJj+UiVkxr/Bed3+tJEYbCMmWtuahEHhrYaHMCoapfrbrbVS3Ms9JjtxqHhLz1LBMfzBTs6KqHuLuMTzWg/lOsqSHJA+tDnEhZpNkcyo2jnvHEGx4qssECY7Y5rHaJCOvqcZLYkHglxIMra4udM0q9p9e6e7xoeeyDEiGnCvJK1evzMao2dasIZhreIZdIzDuLraNNiFp2E6Czf/ChvmzksPE/lzMGv3gF1SnsTxIIzwvicnVOVdwuSwIxIdc5e7xJQawPEgaBkjyKoCrcn0S51KzhsHyq6p+do/Z3XuJHVRAiNFF9bkk9q7CgtTjcm2U52pW0Mm+yLZ2/46qt0TWepOaBbsBNqgOs/ufrUL7Mdf/MJ99AfChfi4ivtTtLCNi3O6MCs7Px6j51qwhmC3jO3qxUcFollVNgwWAL7n7h6UAM/YKYdaWFgLs5+LXA1VTWWY1yW4S7FEVxqnYZh2bA/8WB7OCrqpPJTHmi8WFB0tiozdSG7RTTZLEsUCLVPuqZhXiPy/UXlb4MujkXWv3dRYKcIOM2qGFlXlo1LXmiVmF+oBCbrz2umpQpME1UoJuLlLdNLOy9g2qQeYJiaNZwX2q+909OoSHsyyrnuGSPDB0v3mhsH8RBYpZPc3tcXCCS8McxiEs06rkFtVgd/+y9QasqQSzAqyxwZaF/iCNG1RDWbZVxfWqO9z9RAlGqJYVJdYokllBGwn2hPenxd0Y+eVI5YLKxw8CoYsK5wEsLtYHFtOsoL0Ek7R7urQ77S+SVC54QvrVqZhIjbmqPxW1FVdks6YzLEa9LhfOI6g0mlvj6eJSG7VUZg1DgnESjGyFYDhuYLHiG1KUdshTkrzvP0aqjinmo99TqgMuFtsv1eDS8EtjTU4H+iD2dLCy8kZtKKVRS2nW0LDHqp5zab0kOJuTx8bHl/2sjHq5tOesLBeX8ouU+uggbLyFIbh7XNr2EkyE4WqD+DHAymZ7l3aPleHKUn+ZUsWsqTjPGlp+/sCjEmwts5w+KSutJNjV7/xIRYOG1WPl+lLlNCs42BpaHV3aV6rT7V9SenrYY95vYjLX4tVJ5fxi5T5BEL88ppBNjGQWtuseJDzhsNReGGR574060cpoUhy+YLnBUgeMfNwsiSmGeAwNs4zqRh8VnW6W18Ms78XK4mYrmx/j8CXLHQZEOUL1pGoHl4b49TbV3eUI6qsctBeuUd3kTAq+V50deeLRrClobS3O8yPpWCZzheoNeqwg9JVgGt9ukXQ0crG2f0ncvnAczRqCDudHVDtG0sdIMLdgCv2WE7tLMLZ/YiR9jgSrlcfFOaiOK8i07paxq1w6Mhnj0Vgx2Yney5hOlmdfRoy6yvK4e5yNGveaNVob4JHVJ5K+wmrfu61mIBuDJ9PVVmtGT9sZb6FVRTylKsWsIf0lmGK4ZyQdtQM6q7Hl9zf053pQU6IrCoMvm0Ve+9xCqbGV9AtVmlnD0AWztbBMZpcUr79htTBOVl5bYwZF3hxvtWXfFK9/J8EylKcqMW8q0awhm5ppr7MwIcos1ROmmVVu0p1U55i6pnh9ij2RYNLVlfpLVrJZfW1yij3yeqV5D/oLn7WehEJ1cG8lweK4bMAiyl8L2GBCQwkbOx+R5j3vW2j0YjU8ZarBrB5MZ6u3Aky1wQZ+2XclWH2L7RfzmX+AQ3IXZfkz2LHmlzw+E8Og2GYUq0exJU+qPRlW2h8mJqJ8Uk2FW21m9abANLZzVQc08r4fLMbFwkaMfU+LmVl3VR1kvSBQ50beizH9xyXYRn9RNRZqtZrVs4fVtJg11LOJ9y4w035ste4XEuzbtbrIZkX8XWe9HKg995dgRlq7Jv4/9Jm+ZDXp19VekLVg1mhNBdOiC+wQ2bhLJxXoFpthDbbZpnkSrB17OsvPP0uCtUxYJtLFhAbRzll8l/ck6HKCSb+tpcKrNbN6cM59bwlmFSH+2ydDw5QSmPMzi7MRqjSoltZqgdWyWaNsLsG8TcSIe9njuIeZuhQstdADQqf9BxJsI/obi4ZmzSh/JBiu3Mk9tnewx3hbiynbmtG3SFEzr7JwAYZbaDHxQgsjvndhBfqB5whPa6RZSXXwfwEGAGj0Bf7U4AWjAAAAAElFTkSuQmCC';
        var html = '<div class="modal-ajaxloading">' +
                        '<div class="mask"></div>' +
                        '<div class="box">' +
                            '<img src="' + loadimg + '" alt="">' +
                            '<p>Lodaing...</p>' +
                        '</div>' +
                    '</div>'
        if ($('.modal-ajaxloading').length === 0){
            $('body').append(html);
        }
    };
    $.logout = function(callback) {
        $.setCookie(_GMM_LOGIN_COOKIE_NAME, "0");
        $.setCookie("b_uid", "");
        $.setCookie("phone", "");
        $.setCookie("qqNum", "");
        $.setCookie("nickname", "");
        $.setCookie("displayAccount", "");
        $.setCookie("image", "");
        $.setCookie("userMid", "");
        if( (($.os()=="ios" || $.os()=="gmmios") && window.bridge) || ($.os()=="android" && window.ymm)){
            $.ajax({
                url: _GMM_LOGIN_GMMINF_LOGOUT_URL,
                data: {},
                dataType: "json",
                success: function(data) {
                    $.appLogout()
                    window.location.reload();
                }
            });
        } else {
            $.ajax({
                url: _GMM_LOGIN_GMMINF_LOGOUT_URL,
                data: {},
                dataType: "json",
                success: function(data) {
                    window.location.href =  _GMM_LOGOUT_MYGM_LOGIN_PAGE_URL;
                },
                error: function(data) {
                    $.ajax({
                        url: "https://gmmwlogin.gmmsj.com/v1/sso/logout?redirect_url=" + encodeURIComponent(location.protocol) + "%2F%2Fwww.gmmsj.com%2F",
                        data: {}
                    });
                }
            });
        }
        return true;
    };

    $.login = function(callback) {
        $.ajax({
            url: _GMM_LOGIN_GMMINF_URL,
            data: {},
            dataType: "json",
            success: function(data) {
                if (typeof(callback) == "function") {
                    callback();
                }
            },
            error: function(data) {
            }
        });
        return true;
    };
    $.loginByTicket = function(ticket,callback){
        var paramDatas={
            from:"ghome",
            src_code:"11",
            tk:ticket,
            device_id:$.getDeviceId(),
            system_deviceId:$.getDeviceId()
        };
        $.ajax(
             {
                url:_GMM_LOGIN_GMMINF_URL,
                data:paramDatas,
                dataType:"json",
                success: function (data){
                    if( typeof(data.return_code) != "undefined" && data.return_code==0){
                        var userInfo=data.data;
                        var exp = new Date();
                        exp.setTime(exp.getTime() + 60 * 1000 * 60 * 24);//过期时间1天
                        $.setCookie(_GMM_LOGIN_COOKIE_NAME,"1",exp);
                        $.setCookie("b_uid",userInfo.b_uid);
                        $.setCookie("phone",userInfo.phone);
                        $.setCookie("qqNum",userInfo.u_qq);
                        $.setCookie("nickname",userInfo.nickname);
                        $.setCookie("displayAccount",userInfo.displayAccount);
                        $.setCookie("image",userInfo.image_id);
                        $.setCookie("userMid", userInfo.mid);
                        _GMM_IOS_DO_LOGIN = false;
                        callback && callback();
                        window.parent.location.reload();
                        return;
                    } else if (data.return_code == -777){

                    } else{
                        window.parent.$.closeModal();
                        window.parent.$.loginpanelHasShown = false;
                        $.alert("登录失败" + data.return_message);
                    }
                },
                error:function(data){
                    $.alert("网络访问错误，请稍后再试");
                    window.parent.$.closeModal();
                    window.parent.$.loginpanelHasShown = false;
                }
             }
        );
    };
    var _SMART_SELECT_ = [];
    var _SMART_SELECT_CELL_USER_CLASSNAMES = "";
    $.smartSelectInit = function() {
        var prefix_id = "SM_" + Math.random(1000, 9999);
        $('.smart-select').each(function(index, e) {
            //console.log('smart-select %d is: %o', index, this);
            var selectDom = $(this).next();
            if ($.type(selectDom) == "array") {
                var item = selectDom[0];
                if ($.type(item) == "object" && typeof(item.nodeName) != "undefined" && item.nodeName == "SELECT") {
                    var smartId = prefix_id + "_" + index;
                    $(this).attr("SmartSelectId", smartId);
                    $(selectDom).hide();
                    //console.log('item is: %o',  item);
                    //console.log('item is: %o',  item.options);
                    var smartData = [];
                    var smartValue = "";
                    var smartSelectUiClass = $(this).attr("smartSelectUiClass");
                    if (typeof(smartSelectUiClass) == "undefined") {
                        smartSelectUiClass = "";
                    }
                    var selectChangedCallback = $(this).attr("selectChanged");
                    if (typeof(selectChangedCallback) == "undefined") {
                        selectChangedCallback = "";
                    }

                    for (var i = 0; i < item.options.length; i++) {
                        var opDefine = item.options[i];
                        var optionsItem = {
                            value: opDefine.value,
                            html: opDefine.innerHTML
                        };
                        smartData.push(optionsItem);
                    }
                    var selectIndex = item.options.selectedIndex;
                    if (typeof(selectIndex) != "undefined") {
                        smartValue = item.options[item.options.selectedIndex].value;
                    }
                    var smartData = {
                        id: smartId,
                        value: smartValue,
                        data: smartData,
                        lastValue: smartValue,
                        uiClassName: smartSelectUiClass,
                        selectChanged: selectChangedCallback
                    };
                    if (smartSelectUiClass != "") {
                        if (_SMART_SELECT_CELL_USER_CLASSNAMES == "") {
                            _SMART_SELECT_CELL_USER_CLASSNAMES = smartSelectUiClass;
                        } else {
                            _SMART_SELECT_CELL_USER_CLASSNAMES += " " + smartSelectUiClass;
                        }
                    }
                    _SMART_SELECT_.push(smartData);
                }
            }
        });



        $(document).on("click", ".smart-select", function(e) {
            var clickSmartSelectId = $(this).attr("SmartSelectId");
            console.log('smart-select id is: %s', clickSmartSelectId);
            console.log('_SMART_SELECT_ is: %o', _SMART_SELECT_);
            for (var i = 0; i < _SMART_SELECT_.length; i++) {
                var smartData = _SMART_SELECT_[i];
                if (smartData.id == clickSmartSelectId) {
                    smartData.lastValue = smartData.value;
                    console.log('_SMART_SELECT_ item is: %o', smartData);
                    var _selectHtml = "<div class='container list-block'><ul class='list-group'>";
                    for (var dataIndex = 0; dataIndex < smartData.data.length; dataIndex++) {
                        _selectHtml += "<li>" +
                            "<div class='item-content smart-select-item' onclick='javascript:$.smartItemClickHandle(" + dataIndex + ",\"" + smartData.id + "\");'>" +
                            "<div class='item-inner'>" +
                            "<div class='item-title'>" + smartData.data[dataIndex].html + "</div>";
                        if (smartData.data[dataIndex].value == smartData.value) {
                            _selectHtml += "<span class='icon iconfont icon-succ-sd'>";
                        }
                        _selectHtml += "</div></div></li>";
                    }
                    _selectHtml += "</ul></div>";

                    var currentPage = $(".page-current");
                    if (typeof(currentPage) != "undefined" && currentPage.length > 0) {
                        var maskDiv = $(".mask", currentPage[0]);
                        if (typeof(maskDiv) == "undefined" || maskDiv.length == 0) {
                            $(".page-current").append("<div class='mask'></div>");
                        }
                        var selectDiv = $(".cell-select", currentPage[0]);
                        if (typeof(selectDiv) == "undefined" || selectDiv.length == 0) {
                            var cellHtml = "<div class='cell-select";
                            if (smartData.uiClassName != "") {
                                cellHtml += " " + smartData.uiClassName;
                            }
                            cellHtml += "'>";
                            cellHtml += _selectHtml;
                            cellHtml += "</div>";
                            $(".page-current").append(cellHtml);
                        } else {
                            if (_SMART_SELECT_CELL_USER_CLASSNAMES != "") {
                                $(".cell-select", currentPage[0]).removeClass(_SMART_SELECT_CELL_USER_CLASSNAMES);
                            }
                            if (smartData.uiClassName != "") {
                                $(".cell-select", currentPage[0]).addClass(smartData.uiClassName);
                            }
                            $(".cell-select", currentPage[0]).html(_selectHtml);
                        }
                        $(".mask", currentPage[0]).show();
                        $(".cell-select", currentPage[0]).show();
                    }
                    break;
                }
            }
        });

        $(document).click(function(event) {
            if ($(event.target).is('.smart-select') || $(event.target).parents().is('.smart-select')) {
                return true;
            } else {
                $(".page-current .cell-select").hide();
                $(".page-current .mask").hide();
            }
        });
    };

    $.smartItemClickHandle = function(dataIndex, smartId) {
        $(".page-current .cell-select").hide();
        $(".page-current .mask").hide();
        for (var i = 0; i < _SMART_SELECT_.length; i++) {
            var smartData = _SMART_SELECT_[i];
            if (_SMART_SELECT_[i].id == smartId) {
                if (smartData.value != smartData.data[dataIndex].value) {
                    smartData.value = smartData.data[dataIndex].value;
                    console.log('smart-select value changed');
                    if (smartData.selectChanged != "") {
                        var callFunc = smartData.selectChanged + "(\"" + smartData.value + "\",\"" + smartData.data[dataIndex].html + "\");";
                        console.log('smart-select notify biz function:' + callFunc);
                        eval(callFunc);
                    }
                }
                return;
            }
        }
    };

    $.UserData_LastGames_Save = function(gameData) {

    };

    $.UserData_LastGames_Load = function() {

    };

    $.setLocalStorageIfOutofSize = function(key, value) {
        try {
            window.gLocalStorage[key] = value;
        } catch (ex) {
            console.log('LocalStorage is out of usage, now clear all data.');
            window.gLocalStorage.clear();
            window.gLocalStorage[key] = value;
        }
    };

    //业务各个页面之间共享的持久数据
    $.saveSharedDataItem = function(keyName, dataItem) {
		$.setLocalStorageIfOutofSize(keyName, JSON.stringify(dataItem));
    };
    $.getSharedDataItem = function(keyName) {
		var theCachedDataItemStr = window.gLocalStorage[keyName];
		if (typeof(theCachedDataItemStr) != "undefined") {
			var theCachedDataItem = JSON.parse(theCachedDataItemStr);
			return theCachedDataItem;
		}
    };

    //业务共用数据项 游戏信息
    $.getGameItemByGameId = function(gameId) {
        var games = $.getSharedDataItem("GMM_GAMES");
        if (typeof(games) != "undefined") {
            for (var i = 0; i < games.length; i++) {
                if (gameId == games[i].game_id) {
                    return games[i];
                }
            }
        }
    };

    //最后浏览的4个游戏
    $.getLastLookGames = function() {
        return $.getSharedDataItem("GMM_LAST_LOOK_GAMES");
    };
    $.saveLastLookGame = function(gameId) {
        gameId = "" + gameId;
        var lookGames = $.getLastLookGames();
        if (typeof(lookGames) == "undefined") {
            lookGames = {
                First: gameId,
                Second: -1,
                Third: -1,
                Fourth: -1
            };
        } else {
            var gameExist = (lookGames.First == gameId || lookGames.Second == gameId || lookGames.Third == gameId || lookGames.Fourth == gameId);
            if (gameExist) {
                if (lookGames.Second == gameId) {
                    lookGames.Second = lookGames.First;
                } else if (lookGames.Third == gameId) {
                    lookGames.Third = lookGames.Second;
                    lookGames.Second = lookGames.First;
                } else if (lookGames.Fourth == gameId) {
                    lookGames.Fourth = lookGames.Third;
                    lookGames.Third = lookGames.Second;
                    lookGames.Second = lookGames.First;
                }
                lookGames.First = gameId;
            } else {
                lookGames.Fourth = lookGames.Third;
                lookGames.Third = lookGames.Second;
                lookGames.Second = lookGames.First;
                lookGames.First = gameId;
            }
        }
        $.saveSharedDataItem("GMM_LAST_LOOK_GAMES", lookGames);
    };

    //清除缓存
    $.clearCachedData = function(cacheKey, isOnlySessionStorage) {
        if (typeof(arguments[1]) == "undefined") {
            isOnlySessionStorage = false;
        }
        var storage = isOnlySessionStorage ? window.gSessionStorage : window.gLocalStorage;
        for (var i = 0; i < storage.length; i++) {
            var key = storage.key(i);
            if (key.indexOf(cacheKey) >= 0) {
                storage.removeItem(key);
                break;
            }
        }
    }
    $.clearCachedDataAll = function(isOnlySessionStorage) {
        if (typeof(arguments[0]) == "undefined") {
            isOnlySessionStorage = false;
        }
        var storage = isOnlySessionStorage ? window.gSessionStorage : window.gLocalStorage;
        storage.clear();
    };


    //数据缓存项定义
    $.cachedDataItem = function(dataItem, serverUrl, conditionParams, cachedPeriod) {
        if (!arguments[2]) conditionParams = {};
        if (!arguments[3]) cachedPeriod = 300;

        this.dataItem = dataItem; //数据项
        this.serverUrl = serverUrl; //数据请求地址
        this.conditionParams = conditionParams; //请求参数
        this.cachedPeriod = cachedPeriod; //缓存时长(秒)
        this.cachedTime = (new Date()).getTime(); //缓存时间 转换成毫秒数，避免 toJson 格式化
        var cachedKey = serverUrl + '/';
        var queryKes = [];
        for (var item in conditionParams) {
            queryKes.push(item);
        }
        if (queryKes.length > 0) {
            queryKes.sort();
            for (var i = 0; i < queryKes.length; i++) {
                cachedKey += conditionParams[queryKes[i]];
            }
        }
        this.cachedKey = cachedKey; //缓存Key
        console.log('cachedDataItem:%o', this);
    };

    //写缓存
    $.saveStorage = function(theCachedDataItem, isOnlySessionStorage) {
        if (typeof(arguments[1]) == "undefined") {
            isOnlySessionStorage = false;
        }
        var theCachedDataObjectStr = JSON.stringify(theCachedDataItem);
        if (isOnlySessionStorage) {
			window.gSessionStorage[theCachedDataItem.cachedKey] = theCachedDataObjectStr;
            return true;
        } else {
			$.setLocalStorageIfOutofSize(theCachedDataItem.cachedKey, theCachedDataObjectStr);
			return true;
        }
        return false;
    };

    //缓存组处理
    $.saveCacheKeyInGroup = function(cacheKey, cachedGroupName) {
		var theCachedDataItemStr = window.gLocalStorage[cachedGroupName];
		var groupKeys = [];
		if (typeof(theCachedDataItemStr) != "undefined") {
			var theCachedDataItem = JSON.parse(theCachedDataItemStr);
			for (var savedCachedKey in theCachedDataItem) {
				if (theCachedDataItem[savedCachedKey] == cacheKey) {
					return;
				}
				groupKeys.push(theCachedDataItem[savedCachedKey]);
			}
		}
		groupKeys.push(cacheKey);
		$.setLocalStorageIfOutofSize(cachedGroupName, JSON.stringify(groupKeys));
	};
        //清楚组内所有缓存
    $.clearGroupCachedData = function(cachedGroupName, isOnlySessionStorage) {
        console.log("[CacheMgr][Clear Cache] CacheGroupName=" + cachedGroupName);
		var theCachedDataItemStr = window.gLocalStorage[cachedGroupName];
		if (typeof(theCachedDataItemStr) != "undefined") {
			var theCachedDataItem = JSON.parse(theCachedDataItemStr);
			for (var savedCachedKey in theCachedDataItem) {
				console.log("[CacheMgr][Clear Cache] key=" + theCachedDataItem[savedCachedKey]);
				$.clearCachedData(theCachedDataItem[savedCachedKey], isOnlySessionStorage);
			}
		}
    };

    $.saveStorageByUrlParams = function(dataItem, serverUrl, conditionParams, cachedPeriod, isOnlySessionStorage, cachedGroupName) {
        if (!arguments[2]) conditionParams = {};
        if (!arguments[3]) cachedPeriod = 300;
        if (typeof(arguments[4]) == "undefined") {
            isOnlySessionStorage = false;
        }
        var theCachedDataItem = new $.cachedDataItem(dataItem, serverUrl, conditionParams, cachedPeriod);
        if (typeof(cachedGroupName) != "undefined" && cachedGroupName != "") {
            $.saveCacheKeyInGroup(theCachedDataItem.cachedKey, cachedGroupName);
        }
        return $.saveStorage(theCachedDataItem, isOnlySessionStorage, cachedGroupName);
    };

    //读缓存
    $.getStorage = function(theCachedKey, isOnlySessionStorage) {
        if (typeof(arguments[1]) == "undefined") {
            isOnlySessionStorage = false;
        }
        //console.log("[getStorage] key:"+theCachedKey);

        var theCachedDataItemStr;
        if (isOnlySessionStorage) {
			theCachedDataItemStr = window.gSessionStorage[theCachedKey];
        } else {
			theCachedDataItemStr = window.gLocalStorage[theCachedKey];
        }
        if (typeof(theCachedDataItemStr) != "undefined") {
            var theCachedDataItem = JSON.parse(theCachedDataItemStr);
            if (typeof(theCachedDataItem) != "undefined") {
                var currentTime = (new Date()).getTime();
                var elapseSeconds = parseInt((currentTime - theCachedDataItem.cachedTime) / 1000);
                //console.log("[getStorage] Elapse Seconds:"+elapseSeconds+" Cachable Seconds:"+ theCachedDataItem.cachedPeriod);
                if (elapseSeconds <= theCachedDataItem.cachedPeriod) {
                    return theCachedDataItem.dataItem;
                }
            }
        }
    };

    //清除Ajax保持的缓存
    $.clearAjaxCache = function(serverUrl, conditionParams, isOnlySessionStorage) {
        if (typeof(arguments[1]) == "undefined") {
            conditionParams = {};
        }
        if (typeof(arguments[2]) == "undefined") {
            isOnlySessionStorage = false;
        }
        var cackedKey = serverUrl + '/';
        var queryKes = [];
        for (var item in conditionParams) {
            queryKes.push(item);
        }
        if (queryKes.length > 0) {
            queryKes.sort();
            for (var i = 0; i < queryKes.length; i++) {
                cackedKey += conditionParams[queryKes[i]];
            }
        }
        $.clearCachedData(cackedKey, isOnlySessionStorage);
    };

    $.getStorageByUrlParams = function(serverUrl, conditionParams, isOnlySessionStorage) {
        if (!arguments[1]) conditionParams = {};
        if (typeof(arguments[2]) == "undefined") {
            isOnlySessionStorage = false;
        }
        var cackedKey = serverUrl + '/';
        var queryKes = [];
        for (var item in conditionParams) {
            queryKes.push(item);
        }
        if (queryKes.length > 0) {
            queryKes.sort();
            for (var i = 0; i < queryKes.length; i++) {
                cackedKey += conditionParams[queryKes[i]];
            }
        }
        return $.getStorage(cackedKey, isOnlySessionStorage);
    };

    $.cacheDefaultConditionCheck = function(response) {
        if (typeof(response) != "undefined" && typeof(response.return_code) != "undefined" && response.return_code == 0) {
            return true;
        }
        return false;
    };

    $.ajaxDefaultErrorCallback = function(xhr, type) {
        console.log('ajax call error. detail message: %o %o', xhr, type);
    };

    $.ajaxBridgeCache = function(serverUrl, successCallback, conditionParams, method, isOnlySessionStorage, cachedPeriod, cacheConditionCheck, errorCallback, cachedGroupName, hideLoading) {

        if (!arguments[2]) conditionParams = {};
        if (!arguments[3]) method = "GET";
        if (typeof(arguments[4]) == "undefined") {
            isOnlySessionStorage = false;
        }
        if (!arguments[5]) cachedPeriod = 300;
        if (!arguments[6]) cacheConditionCheck = $.cacheDefaultConditionCheck;
        if (!arguments[7]) errorCallback = $.ajaxDefaultErrorCallback;

        var theCachedDataItem = $.getStorageByUrlParams(serverUrl, conditionParams, isOnlySessionStorage);
        //这个地方控制读缓存，调试时先去掉
        // if (typeof(theCachedDataItem) != "undefined") {
        //     if (typeof(successCallback) == "function") {
        //         successCallback(theCachedDataItem);
        //     }
        // } else {
        var params = conditionParams.params ? JSON.parse(conditionParams.params) : {};
        params.device_id = $.getDeviceId();
        params.system_deviceId = $.getDeviceId();
        conditionParams.params = JSON.stringify(params);
        conditionParams.src_code = 11;
        conditionParams.app_version = 0;
            $.showIndicator();
            if (hideLoading == true){
                $.hideIndicator();
            }
            $.ajax({
                type: method,
                url: serverUrl,
                data: conditionParams,
                dataType: 'json',
                cache: false,
                success: function(response) {
                    $.hideIndicator();
                    // 缓存接口数据
                    // if (cacheConditionCheck(response)) {
                    //     $.saveStorageByUrlParams(response, serverUrl, conditionParams, cachedPeriod, isOnlySessionStorage, cachedGroupName);
                    // }
                    if (response.return_code !== 0){
                        if (conditionParams.method !== 'RecommendProduct4Index') {
                            $.toast(response.return_message);
                        }
                    } else {
                        if (typeof(successCallback) == "function") {
                            successCallback(response);
                        }
                    }
                },
                //error: errorCallback
                error: function(){
                    $.hideIndicator();
                    $.toast('网络故障，请稍后再试！');
                }
            });
        //}
    };

    $.unApplyBinding = function(node) {
        $(node).find("*").each(function() {
            $(this).unbind();
        });
        ko.cleanNode(node);
    };

    $.BizReturnCodeCheck = function(response, expect_code) {
        var expct_code_val = (typeof(expect_code) == "undefined" ? 0 : expect_code);
        if (typeof(response) != "undefined" && typeof(response.return_code) != "undefined" && response.return_code == expct_code_val) {
            return true;
        }
        return false;
    };
    $.BizReturnDataCheck = function(response, item_key, check_as_array) {
        var check_length = (typeof(check_as_array) != "undefined" && check_as_array == true);
        if (typeof(response.data) != "undefined") {
            if (typeof(response.data[item_key]) != "undefined") {
                if (check_length) {
                    return response.data[item_key].length > 0;
                } else {
                    return true;
                }
            }
        }
        return false;
    };
    $.BizDataCheckDefines = function(data, itemKeys) {
        if (typeof(data) != "undefined" && typeof(itemKeys) != "undefined") {
            for (var i = 0; i < itemKeys.length; i++) {
                if (typeof(data[itemKeys[i]]) == "undefined") {
                    return false;
                }
            }
            return true;
        }
        return false;
    };

    $.loginStatusCheck = function(xhr, options) {
        var f = options.success;
        var traceChannel = $.getCookie('trace_channel');
        var referrer = document.referrer;
        var referrerDomain = referrer && /^((?!gmmsj.com|gmm01.com).)*$/.test(referrer) ? '$' + referrer.split('/')[2] : '';
        var appChannel = $.osChannel() + (traceChannel ? '$' + traceChannel : referrerDomain);
        if(options.url.indexOf('?') >-1 ){
            options.url += '&app_channel=' + appChannel;
        }else{
            options.url += '?app_channel=' + appChannel;
        }

        options.success = function(context, data, status, xhr) {
            if (context && context.return_code == -777) { //登录态失效,重新登录
                $.hideIndicator();
                $.clearGroupCachedData("GMM_UserInfo");
                $.clearGroupCachedData("Page_Favor");
                var isQueryUserNewMessageCall = (options.url.indexOf("method=QueryMessage") > 0 && options.url.indexOf("check_new=1") > 0);
                if (isQueryUserNewMessageCall == false && options.url.indexOf("method=QueryLastBuyProduct") < 0) {
                    var eventSrc = "check Ajax return_code=-777 url:" + options.url;
                    var url = $.delQueryStringByName(location.href,'ticket');//登录后刷新当前页面,但是要去掉url带的ticket,ios进入h5会带入ticket
                    $(document).trigger("gmm_notlogin", [eventSrc,function(){window.location.href = url}]);
                    return;
                }
                //如果未登录时查询新消息不需要toast报错，使用这段
                if (isQueryUserNewMessageCall == true){
                    return;
                }
            }
            // } else if (context && context.return_code == -10002) {
            //     $.logout();
            //     $.clearGroupCachedData("GMM_UserInfo");
            //     $.clearGroupCachedData("Page_Favor");
            //     $.alert("-10002 错误，如非参数缺失，则为服务器异常，请关闭浏览器");
            //     return;
            // } else if (context && typeof(context.return_code) != 'undefined' && context.return_code != 0 && (typeof(context.return_message) == 'undefined' || context.return_message == '')) {
            //     context.return_message = '未知错误，请稍后再试(' + context.return_code + ')';
            // }
            f(context, data, status, xhr);
        };
        options.timeout = 20000;
        return true;
    };

    //标记已读过新消息
    $.GmmMarkReadNewMsg = function() {
        if ($.isLogin() && $.getLoginBUid() != "") {
            var user_msg_new_data_item = "_USER_MSG_NEW_STATUS";
            var user_msg_new_check_period = 60;
            var userMsgStatus = $.getSharedDataItem(user_msg_new_data_item);
            if (typeof(userMsgStatus) != "undefined") {
                userMsgStatus.haveNewMsg = 0;
                userMsgStatus.b_uid = $.getLoginBUid();
            } else {
                userMsgStatus = {
                    b_uid: $.getLoginBUid(),
                    cachedTime: (new Date()).getTime(),
                    haveNewMsg: 0
                };
            }
            $.saveSharedDataItem(user_msg_new_data_item, userMsgStatus);
        }
    };

    //是否有新消息设置
    $.GmmUserMsgNewCheck = function(callback) {
        var user_msg_new_data_item = "_USER_MSG_NEW_STATUS";
        var user_msg_new_check_period = 60; //是否有新消息检查间隔
        if ($.isLogin() && $.getLoginBUid() != "") {
            var userMsgStatus = $.getSharedDataItem(user_msg_new_data_item);
            if (typeof(userMsgStatus) != "undefined") {
                var b_uid = $.getLoginBUid();
                if (userMsgStatus.b_uid == b_uid) {
                    var current_time = (new Date()).getTime();
                    var elapseSeconds = parseInt((current_time - userMsgStatus.cachedTime) / 1000);
                    if (elapseSeconds < user_msg_new_check_period) {
                        var haveNewMsg = (userMsgStatus.haveNewMsg == 1);
                        callback(haveNewMsg);
                        return;
                    }
                }
            }
            var user_msg_url = "/gmminf/accountapi/config";
            var params = {
                src_code: 11,
                method: "QueryMessage",
                check_new: "1",
                params: JSON.stringify({
                    is_read: 0,
                    count: 2,
                    page: 1
                })
            };
            $.ajaxBridgeCache(user_msg_url, function(response) {
                    var haveNewMsg = ($.BizReturnCodeCheck(response) && typeof(response.data) != "undefined" && typeof(response.data.sum) != "undefined" && response.data.sum > 0);
                    var userMsgStatus = {
                        b_uid: b_uid,
                        cachedTime: (new Date()).getTime(),
                        haveNewMsg: haveNewMsg ? 1 : 0
                    };
                    $.saveSharedDataItem(user_msg_new_data_item, userMsgStatus);
                    callback(haveNewMsg);
                },
                params, "GET", false, 0,
                function(response) {
                    return false;
                });
        } else {
            callback(false); //没有用户身份:没有新消息
        }
    };

    $.formatDate = function(d) {
        var dateNow = new Date().getTime(),
            dateOld = new Date(d.replace(/-/g, "/")).getTime(),
            dateNew = dateNow - dateOld,
            s = 1000,
            m = s * 60,
            h = m * 60,
            d = h * 24,
            y = d * 365,
            timeType = [s, m, h, d, y],
            dateFmt = ['秒', '分钟', '小时', '天', '年'];

        function find(array, val) {
            //如果值小于timeType最小的值时，则0
            if (val < Math.min.apply(null, array)) {
                return 0;
            };
            //如果值大于timeType最大的值时，则最高一档
            if (val > Math.max.apply(null, array)) {
                return array.length - 1;
            };
            var idx = 0,
                i = 0,
                j = array.length;
            for (; i < j; i++) {
                if (array[i] > val) {
                    idx = i - 1;
                    break;
                }
            }
            return idx;
        };
        switch (dateFmt[find(timeType, dateNew)]) {
            case '秒':
                return (parseInt(dateNew / s) + "秒前");
                break;
            case '分钟':
                return (parseInt(dateNew / m) + "分钟前");
                break;
            case '小时':
                return (parseInt(dateNew / h) + "小时前");
                break;
            case '天':
                return (parseInt(dateNew / d) + "天前");
                break;
            case '年':
                return (parseInt(dateNew / y) + "年前");
                break;
        }
    }

    $.getDeviceId = function(){
        var  deviceIdName = "device_id";
        var  deviceIdName2 = "deviceId";

        function uuid(len, radix) {
            var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
            var uuid = [], i;
            radix = radix || chars.length;

            if (len) {
                // Compact form
                for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
            } else {
                // rfc4122, version 4 form
                var r;

                // rfc4122 requires these characters
                uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
                uuid[14] = '4';

                // Fill in random data.  At i==19 set the high bits of clock sequence as
                // per rfc4122, sec. 4.1.5
                for (i = 0; i < 36; i++) {
                    if (!uuid[i]) {
                        r = 0 | Math.random() * 16;
                        uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
                    }
                }
            }

            return uuid.join('');
        }
        function encodeUuid(str){
            var uuidStr="";
            //5,7,9,10,13  gwp01
            var list = str.split("");
            if ($.os() == 'gmmios'){
                list[0] = "i";
                list[1] = "o";
                list[2] = "s";
            } else if ($.os() == "android" && window.ymm){
                list[0] = "a";
                list[1] = "d";
            } else if ($.isAlipayClient()) {
                list[0] = "z";
                list[1] = "f";
                list[2] = "b";
            } else {
                list[0] = "h";
                list[1] = "5";
            }
            //这里和checkOld对应
            list[4] = "g";
            list[6] = "w";
            list[8] = "p";
            list[9] = "0";
            list[12] = "1";
            uuidStr = list.join("");
            return uuidStr;
        }
        function checkOld(str){
            if ($.os() == 'gmmios'){
                if (str[0] == "i" && str[1] == "o" && str[2] == "s" && str[4] == "g" && str[6] == "w" && str[8] == "p" && str[9] == "0" && str[12] == "1"){
                    return false;
                } else {
                    return true;
                }
            } else if ($.os() == "android" && window.ymm){
                if (str[0] == "a" && str[1] == "d" && str[4] == "g" && str[6] == "w" && str[8] == "p" && str[9] == "0" && str[12] == "1"){
                    return false;
                } else {
                    return true;
                }
            } else if ($.isAlipayClient()) { 
                if (str[0] == "z" && str[1] == "f" && str[2] == "b" && str[4] == "g" && str[6] == "w" && str[8] == "p" && str[9] == "0" && str[12] == "1"){
                    return false;
                } else {
                    return true;
                }
            } else {
                if (str[0] == "h" && str[1] == "5" && str[4] == "g" && str[6] == "w" && str[8] == "p" && str[9] == "0" && str[12] == "1"){
                    return false;
                } else {
                    return true;
                }
            }
        }
        var deviceId = ""
        //首先查找localStorage中的device_id，如果没有，去url上找
        if($.getLocalStorage('device_id')) {
          deviceId = $.getLocalStorage('device_id')
        }else{
          if($.getQueryStringByName('device_id')) {
            deviceId = $.getQueryStringByName('device_id')
            $.setLocalStorage('device_id', deviceId)
          }
        }
        if(deviceId && deviceId != ""){
            return deviceId;
        }else{
            deviceId = $.getCookie(deviceIdName);
            var expires_date = new Date('2066/01/01'); //deviceid在cookie过期时间50年
            if(!deviceId || deviceId == ""){
                deviceId = "v2_" + encodeUuid(uuid(32));
                if ($.getCookie("gmm_login_status") == 1){//已登录用b_uid写入cookie当deviceId
                    deviceId = deviceId + "_" + $.getCookie("b_uid");
                }
            } else {
                if (deviceId.indexOf("v2_") == -1 || checkOld(deviceId.split("_")[1])){ //有deviceId但是是旧的不带v2_，就清空
                    $.setCookie(deviceIdName,"",new Date('1970/01/01'));//删除老deviceId
                    $.setCookie(deviceIdName2,"",new Date('1970/01/01'));//删除老deviceId
                    deviceId = "v2_" + encodeUuid(uuid(32));
                }
                if ($.getCookie("gmm_login_status") == 1) {//已登录用b_uid写入cookie当deviceId
                    if (deviceId.split("_").length == 2){ //还没有b_uid时加上
                        deviceId = deviceId + "_" + $.getCookie("b_uid");
                    }
                } else {
                    if (deviceId.split("_").length == 3){ //未登录deviceId去掉b_uid
                        deviceId = deviceId.slice(0,deviceId.lastIndexOf("_"));
                    }
                }
            }
            $.setCookie(deviceIdName,deviceId,expires_date,"/",location.port ? "" : "gmmsj.com");
            $.setCookie(deviceIdName2,deviceId,expires_date,"/",location.port ? "" : "gmmsj.com");
            return deviceId;
        }
    }

    $.setLocalStorage = function (keyName, value){
        try{
            window.localStorage[keyName]=JSON.stringify(value);
        }
        catch(ex){
            window.localStorage.clear();
            window.localStorage[keyName]=JSON.stringify(value);
        }
    }
    $.getLocalStorage = function(keyName) {
        var theCachedDataItemStr = window.localStorage[keyName];
        if(typeof(theCachedDataItemStr) != "undefined"){
            var theCachedDataItem=JSON.parse(theCachedDataItemStr);
            return theCachedDataItem;
        }
    }

    $.copyTextToClipboard = function(text) {
        var textArea = document.createElement("textarea")

        textArea.style.position = 'fixed'
        textArea.style.top = 0
        textArea.style.left = 0
        textArea.style.width = '2em'
        textArea.style.height = '2em'
        textArea.style.padding = 0
        textArea.style.border = 'none'
        textArea.style.outline = 'none'
        textArea.style.boxShadow = 'none'
        textArea.style.background = 'transparent'
        textArea.value = text

        document.body.appendChild(textArea)

        textArea.select()

        try {
          var msg = document.execCommand('copy') ? '成功' : '失败';
          if (document.execCommand('copy') == true){
            $.toast('复制成功');
          } else {
            $.toast('你的浏览器不支持一键复制');
          }
        } catch (err) {
          console.log('不能使用这种方法复制内容')
        }

        document.body.removeChild(textArea)
    }
    //表情处理 #01对应01.png
    $.getEmoji = function(str){
        var baseurl = '/m/all/img/emoji/';
        var num = 80;
        var arr = [];
        for (var i = 1;i<num+1;i++){
            i<10 ? arr.push('0' + i + '.png') : arr.push(i + '.png')
        }
        return str2 = str.replace(/#0?(\d+)/g, function(item, index){
            return '<img style="width:1rem" src="' + baseurl  + arr[index-1] +'" />&nbsp;';
        });
    }
    //判断是否在支付宝小程序内
    $.isAlipayClient = function(){
        if (navigator.userAgent.indexOf('AlipayClient') > -1){
            return true
        } else {
            return false
        }
    }
    $(function() {
        //$.router.savePageNoCaches("/m/buyselect/selgame.html", true);
        $.router.savePageNoCaches("/h5/selgame/index.html", true);
        $.router.savePageNoCaches("/m/index/index.html", true);
        $.router.savePageNoCaches("/h5/order/list/index.html", true);
    });
    // $.ajaxSettings =
    $.ajaxSettings.beforeSend = $.loginStatusCheck;
    //页面渲染后gmmios里隐藏返回
    $(document).bind("pageInit", function() {
        if ($.os() === 'gmmios') {
            $('.bar.bar-nav .icon-back-sd').hide();
            $('.bar.bar-nav .title').css('paddingLeft','1.0rem');
            $('.bar.bar-nav .icon-btn-message').hide();
            $('.bar.bar-nav .icon-btn-back').hide();
            $('.bar.bar-nav .icon-msg2-sd').attr('href','');
            $('.bar.bar-nav .icon-msg2-sd').bind('click',function(e){
                e.preventDefault()
                window.bridge.callHandler('showSystemMessages',function(){})
            })
            $('.icon-btn-cont.icon-btn-back').hide();
            $('.icon-btn-cont.icon-btn-message').attr('onclick', '').click(function(e){
                window.bridge.callHandler('showSystemMessages',function(){})
            });
        }
        if ($.isLogin()){
            $.doHaveNewCoupons()
        }
    });

    // 判断url上是否有trace_channel参数，用作推广统计。
    var referrer = document.referrer;
    var traceChannel = $.getQueryStringByName('trace_channel');
    var referrerTraceChannel = referrer && /^((?!gmmsj.com|gmm01.com).)*$/.test(referrer) ? referrer.split('/')[2] : '';
    if (!$.getCookie('trace_channel')) {
        if (traceChannel) {
            $.setCookie('trace_channel', traceChannel);
        } else if (referrerTraceChannel) {
            $.setCookie('trace_channel', referrerTraceChannel);
        }
    }

    var locatPath = window.location.pathname.toLowerCase();
    if(locatPath == "/h5/goods/list/index.html" || locatPath == "/h5/goods/detail/index.html" || locatPath == "/m/index/msg.html"){

    }else{
        sessionStorage.removeItem('qyRecord')
        sessionStorage.removeItem('scrollTop')
    }

})(Zepto)
